export default __webpack_public_path__ + "static/media/chemistry.8667e952.jpg";